<template>
  <div class="user">
    <!-- 搜索区域保持不变 -->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="招聘信息名称">
          <el-input placeholder="请输入招聘信息名称" v-model="formInline.search"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加招聘信息</el-button>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <!-- 原有列保持不变 -->
            <el-table-column prop="name" label="名称"></el-table-column>
            <el-table-column prop="daily_salary" label="薪资"></el-table-column>
            <el-table-column prop="work_days" label="用工天数"></el-table-column>
            <el-table-column prop="required_number" label="需求人数"></el-table-column>
            <el-table-column prop="company_name" label="公司名称"></el-table-column>
            <el-table-column prop="work_location" label="工作地点"></el-table-column>
            <el-table-column prop="work_city" label="所在城市"></el-table-column>
            <el-table-column prop="experience_required" label="经验要求"></el-table-column>
            <el-table-column prop="education_required" label="学历要求"></el-table-column>
            <el-table-column prop="job_type" label="职位类型"></el-table-column>
            <el-table-column prop="hr_contact" label="联系方式"></el-table-column>
            <el-table-column prop="application_count" label="报名人数"></el-table-column>
            <el-table-column prop="expire_time" label="截止时间"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            
            <!-- 新增审核状态列 -->
            <el-table-column label="审核状态" width="120">
              <template slot-scope="scope">
                <el-tag :type="getStatusTagType(scope.row.is_status)" size="small">
                  {{ getStatusText(scope.row.is_status) }}
                </el-tag>
              </template>
            </el-table-column>
            
            <!-- 操作列增加审核按钮 -->
            <el-table-column fixed="right" label="操作" width="180">
              <template slot-scope="scope">
                <!-- 审核按钮（仅当状态为0未审核时显示） -->
                <el-button 
                  v-if="scope.row.is_status === 0" 
                  @click="auditClick(scope.row, 1)" 
                  type="text" 
                  size="small"
                  style="color: #67C23A;"
                >
                  通过
                </el-button>
                <el-button 
                  v-if="scope.row.is_status === 0" 
                  @click="auditClick(scope.row, 2)" 
                  type="text" 
                  size="small"
                  style="color: #F56C6C;"
                >
                  拒绝
                </el-button>
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add" @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :recruitment_info_id="recruitment_info_id" v-if="open_edit" @close="closeEdit"></Edit>
  </div>
</template>

<script>
import Recruitment_infoApi from '@/api/recruitment_info.js';
import Add from './part/add.vue';
import Edit from './part/edit.vue';

export default {
  components: {
    Add,
    Edit,
  },
  data() {
    return {
      loading: true,
      tableData: [],
      pageSize: 20,
      totalDataNumber: 0,
      curPage: 1,
      form: {},
      formInline: {
        search: ""
      },
      open_add: false,
      open_edit: false,
      recruitment_info_id: "",
      dialogVisible: false,
    };
  },
  created() {
    this.getTableList();
  },
  methods: {
    // 获取审核状态对应的文本
    getStatusText(status) {
      const statusMap = {
        0: '未审核',
        1: '已通过',
        2: '已拒绝'
      };
      return statusMap[status] || '未知状态';
    },
    
    // 获取审核状态对应的标签类型
    getStatusTagType(status) {
      const typeMap = {
        0: 'warning',
        1: 'success',
        2: 'danger'
      };
      return typeMap[status] || '';
    },
    
    // 审核操作
    auditClick(row, status) {
      const actionText = status === 1 ? '通过' : '拒绝';
      this.$confirm(`确定要${actionText}该招聘信息吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        Recruitment_infoApi.auditRecruitment({
          recruitment_info_id: row.recruitment_info_id,
          status: status
        }).then(res => {
          if (res.code === 1) {
            this.$message.success(`招聘信息${actionText}成功`);
            this.getTableList();
          } else {
            this.$message.error(res.msg || `操作失败`);
          }
        }).catch(error => {
          this.$message.error('请求失败');
        });
      }).catch(() => {
        this.$message.info('已取消操作');
      });
    },
    
    // 其他原有方法保持不变
    dialogFormVisible() {
      this.dialogVisible = false;
    },
    closeAdd(e) {
      this.open_add = false;
      this.getTableList();
    },
    closeEdit(e) {
      this.open_edit = false;
      this.getTableList();
    },
    getData() {
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },
    getTableList() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      Recruitment_infoApi.list(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {
          self.loading = false;
        });
    },
    addClick() {
      this.open_add = true;
    },
    editClick(row) {
      this.recruitment_info_id = row.recruitment_info_id;
      this.open_edit = true;
    },
    deleteClick(row) {
      this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        Recruitment_infoApi.del({ recruitment_info_id: row.recruitment_info_id }, true)
          .then(data => {
            if (data.code == 1) {
              this.$message.success('删除成功');
              this.getTableList();
            } else {
              this.$message.error(data.msg || '删除失败');
            }
          });
      }).catch(() => {});
    }
  }
};
</script>

<style>
/* 可以添加一些自定义样式 */
.el-tag--success {
  background-color: #f0f9eb;
  border-color: #e1f3d8;
  color: #67c23a;
}
.el-tag--warning {
  background-color: #fdf6ec;
  border-color: #faecd8;
  color: #e6a23c;
}
.el-tag--danger {
  background-color: #fef0f0;
  border-color: #fde2e2;
  color: #f56c6c;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/recruitment_info/index/index.vue